<template>
  <figure class="photo-wrapper">
  <img :src="photoUrl" :style="renderStyle()" />
  <figcaption><i><div v-html="caption"/></i></figcaption>
  </figure>
</template>

<script>
export default {
  props: {
    caption: String,
    rounded: false,
    photoUrl: null
  },
  methods: {
    renderStyle() {
      return {
        'border-radius': this.rounded ? '100%' : 'none'
      }
    }
  }
}
</script>

<style scoped>

img {
  border-radius: 4px;
  width: 100%;
}

.photo-wrapper {
  text-align: center; 
  margin: auto !important;
}
</style>